import React, { useMemo } from "react";
import { useParams } from "react-router";
import { useCustomers } from "./useCustomers";

export default function useSelectedCustomer() {
  const { id } = useParams();
  const { data: customers } = useCustomers();
  const selectedCustomer = useMemo(() => {
    return customers?.find((c) => c.dataManagerID === id);
  }, [id, customers]);

  return selectedCustomer;
}
